module.exports = __webpack_public_path__ + "img/SEL_BG_pattern.f39b5d31.svg";